import axios from 'axios';
import Modal, { bemClasses } from './modal';

const instance = axios.create({
    timeout: 60000,
    withCredentials: true,
});

export const ASYNC_ACTION_DISPLAY_POPUP = 'DisplayPopup';
export const ASYNC_ACTION_REDIRECT = 'Redirect';
export const ASYNC_ACTION_ERRORS = 'DisplayErrors';

instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

instance.interceptors.response.use((response) => {
    if (isValidationError(response)) {
        return Promise.reject(response);
    }

    // handle response only in case of post request
    if (response.config.method === 'post') {
        return handleAsyncAction(response).then(() => response);
    }

    return response;
}, (error) => {
    if (!axios.isCancel(error)) {
        if (error && error.response) {
            console.error(error.response);

            if (!isValidationError(error.response)) {
                console.error(error);
            }
        }
    }

    return Promise.reject(error);
});

export default instance;

export function isValidationError({ data }) {
    return (typeof data === 'object') && (data.action === ASYNC_ACTION_ERRORS) && ('errors' in data);
}

export function getValidationErrors({ data }) {
    return data.errors;
}

export function isResponseHandled(response) {
    return ('isHandledGlobally' in response);
}

export function isJsonContentType(response) {
    const contentType = response.headers['content-type'];
    if (contentType) {
        return contentType.includes('application/json');
    }

    return false;
}

export function isHtmlContentType(response) {
    const contentType = response.headers['content-type'];
    if (contentType) {
        return contentType.includes('text/html');
    }

    return false;
}

function markResponseHandled(response) {
    response.isHandledGlobally = true;
}

function showModal(modalHtmlPromise) {
    return modalHtmlPromise.then((html) => {
        (new Modal(html, {
            bemList: [bemClasses.MOBILE_FIXED, bemClasses.AUTO],
            destroyOnClose: true,
        })).open();
    });
}

function getModalHtmlPromise(url) {
    return instance.get(url).then((response) => response.data);
}

function handleAsyncAction(response) {
    if (isJsonContentType(response)) {
        switch (response.data.action) {
            case ASYNC_ACTION_DISPLAY_POPUP:
                markResponseHandled(response);
                return showModal(getModalHtmlPromise(response.data.url));
            case ASYNC_ACTION_REDIRECT:
                markResponseHandled(response);
                window.location.href = response.data.url;
                break;
            default:
                return Promise.resolve(response);
        }
    }

    if (isHtmlContentType(response)) {
        markResponseHandled(response);
        return showModal(Promise.resolve(response.data));
    }

    return Promise.resolve();
}
